export const DEFAULT_AVAILABILITY_DURATION = '5';
export const ROWS_PER_PAGE = 5;
